import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'external-system-setting',
    pluginName: 'ADMIN',
    entityName: 'EXTERNAL_SYSTEM_SETTING',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true
});

// Fetch externalSystemSetting action creators
export const fetchExternalSystemSettingInit = () => {
    return crudActions.fetchInit();
};
export const fetchExternalSystemSettingStart = () => {
    return crudActions.fetchStart();
};
export const fetchExternalSystemSettingSuccess = (fetchExternalSystemSettingCount, listExternalSystemSettingCount) => {
    return crudActions.fetchSuccess(fetchExternalSystemSettingCount, listExternalSystemSettingCount);
};
export const fetchExternalSystemSettingFail = () => {
    return crudActions.fetchFail();
};

export const fetchExternalSystemSettingCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchExternalSystemSettingStart());
        try {
            let countRes = await rest.post("external-system-setting/count", filterData, { cancelToken: options.countSource.token });
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchExternalSystemSettingSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            dispatch(fetchExternalSystemSettingFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch external system settings."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchExternalSystemSettingFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch external system settings."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 }
        }
    }
}

export const fetchExternalSystemSetting = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchExternalSystemSettingStart());
        try {
            let listRes = await rest.post("external-system-setting/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchExternalSystemSettingSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data }
            }
            dispatch(fetchExternalSystemSettingFail());
            return { data: [] };
        } catch (error) {
            dispatch(fetchExternalSystemSettingFail());
            return { data: [] }
        }
    }
}

// Create externalSystemSetting  action creators
export const createExternalSystemSettingInit = () => {
    return crudActions.createInit();
};
export const createExternalSystemSettingStart = () => {
    return crudActions.createStart();
};
export const createExternalSystemSettingSuccess = createdExternalSystemSetting => {
    return crudActions.createSuccess(createdExternalSystemSetting);
};
export const createExternalSystemSettingFail = error => {
    return crudActions.createFail(error);
};
export const createExternalSystemSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createExternalSystemSettingStart());
        try {
            let res = await rest.post('/external-system-setting/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createExternalSystemSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created external system setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createExternalSystemSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create external system setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create external system setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createExternalSystemSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Delete externalSystemSetting  action creators
export const bulkDeleteExternalSystemSettingInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteExternalSystemSettingStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteExternalSystemSettingSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteExternalSystemSettingFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteExternalSystemSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteExternalSystemSettingStart());
        try {
            let res = await rest.post('/external-system-setting/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteExternalSystemSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted external system settings.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteExternalSystemSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete external system settings."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete external system settings."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteExternalSystemSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit externalSystemSetting  action creators
export const editExternalSystemSettingInit = () => {
    return crudActions.editInit();
};
export const editExternalSystemSettingStart = () => {
    return crudActions.editStart();
};
export const editExternalSystemSettingSuccess = editedExternalSystemSetting => {
    return crudActions.editSuccess(editedExternalSystemSetting);
};
export const editExternalSystemSettingFail = error => {
    return crudActions.editFail(error);
};
export const editExternalSystemSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editExternalSystemSettingStart());
        try {
            let res = await rest.post('/external-system-setting/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editExternalSystemSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated external system setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editExternalSystemSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit external system setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit external system setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editExternalSystemSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load externalSystemSetting action creators
export const loadExternalSystemSettingInit = () => {
    return crudActions.loadInit();
};
export const loadExternalSystemSettingStart = () => {
    return crudActions.loadStart();
};
export const loadExternalSystemSettingSuccess = loadedExternalSystemSetting => {
    return crudActions.loadSuccess(loadedExternalSystemSetting);
};
export const loadExternalSystemSettingFail = error => {
    return crudActions.loadFail(error);
};
export const loadExternalSystemSetting = (loadParams, options) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

export const getBearerToken = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let token = await rest.post("servicenow/get-token", params);
            if (token.data && token.data.succeeded) {
                snackActions.snackBar({
                    message: `Bearer token retrieved successfully.`,
                    options: {
                        variant: 'success'
                    }
                });
                return { data: token.data.result.data }
            }
            snackActions.snackBar({
                message: `${token && token.data ? token.data.message : "Cannot get bearer token."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot get bearer token."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 }
        }
    }
}